import Vue from 'vue';
import numeral from 'numeral';

/**
* Use Numeral.js to format numbers (and register as Vue filter function)
* @param  {number} value number to format
* @param  {string} [format] numeral.js formatting string
* @return {string}           formatted number
*/
function numeralFormat(value, format = '0,0.00') {
    return numeral(value).format(format);
}

/**
 * Round to remove decimals above a threshold
 * @param  {number} value     number to format
 * @param  {string} [format='0,0[.][00]'] numeral.js formatting string
 * @param  {number} [threshold=10]           minimum value before rounding
 * @return {string}           formatted number
 */
function flexibleNumeralFormat(value, format = '0,0[.][00]', threshold = 10) {
    if (value >= threshold) {
        value = Math.round(value);
    }
    return numeral(value).format(format);
}

// register vue filters
Vue.filter('numeral', numeralFormat);
Vue.filter('flexibleNumFormat', flexibleNumeralFormat);



// WEBPACK FOOTER //
// ./src/js/controls/formattingFilters.js